import { SHOW_SCONTISTICA_MODAL, HIDE_SCONTISTICA_MODAL } from "../actions/scontisticaModal_actions";
import _ from "lodash";

export function scontisticaModalReducer(state = { type:'', header: undefined, show: false, function: undefined, obj: undefined  }, action) {
  if (_.isEmpty(action) || _.isEmpty(action.type)) return state
  const newState = state
  switch (action.type) {
    case SHOW_SCONTISTICA_MODAL:
      newState.type = action.payload.type
      newState.header = action.payload.header
      newState.show = true
      newState.function = action.payload.function
      newState.obj = action.payload.obj
      break;
    case HIDE_SCONTISTICA_MODAL:
      newState.type = ''
      newState.header = undefined
      newState.show = false
      newState.function = undefined
      newState.obj = undefined
      break;
    default:
      break;
  }
  return Object.assign({}, state, newState)
}
